<template>
  <div class="v2-has-both">
    <v2-head />
    <v2-menu />

    <div class="menu-act v2-wrap clearfix">
      <div class="com menus">
        <div class="menu-item">
          <router-link to="/v2/homestay" class="top-line clearfix">
            <div class="icon-tit">
              <img class="ico" src="~@/assets/images/v2/menu01.png" alt="" />
              <span class="tit">店家</span>
            </div>
            <img class="arrow" src="~@/assets/images/v2/more_arrow.png" alt="" />
          </router-link>
          <div class="det text-ellipsis">
            <router-link class="det-item" to="/v2/homestay">民宿</router-link>
            <span class="fh">/</span>
            <router-link class="det-item" to="/v2/homestay">酒店</router-link>
            <span class="fh">/</span>
            <router-link class="det-item" to="/v2/homestay">农家乐</router-link>
          </div>
        </div>
        <div class="menu-item disabled">
          <router-link to="" class="top-line clearfix">
            <div class="icon-tit">
              <img class="ico" src="~@/assets/images/v2/menu02.png" alt="" />
              <span class="tit">认种认养</span>
            </div>
            <img class="arrow" src="~@/assets/images/v2/more_arrow.png" alt="" />
          </router-link>
          <div class="det text-ellipsis">
            <router-link class="det-item" to="">果树认养</router-link>
            <span class="fh">/</span>
            <router-link class="det-item" to="">家禽认养</router-link>
            <span class="fh">/</span>
            <router-link class="det-item" to="">土地认养</router-link>
          </div>
        </div>
        <div class="menu-item disabled">
          <router-link to="" class="top-line clearfix">
            <div class="icon-tit">
              <img class="ico" src="~@/assets/images/v2/menu03.png" alt="" />
              <span class="tit">农业体验</span>
            </div>
            <img class="arrow" src="~@/assets/images/v2/more_arrow.png" alt="" />
          </router-link>
          <div class="det text-ellipsis">
            <router-link class="det-item" to="">采摘</router-link>
            <span class="fh">/</span>
            <router-link class="det-item" to="">研学</router-link>
            <span class="fh">/</span>
            <router-link class="det-item" to="">农场活动</router-link>
          </div>
        </div>
        <div class="menu-item disabled">
          <router-link to="" class="top-line clearfix">
            <div class="icon-tit">
              <img class="ico" src="~@/assets/images/v2/menu04.png" alt="" />
              <span class="tit">美食</span>
            </div>
            <img class="arrow" src="~@/assets/images/v2/more_arrow.png" alt="" />
          </router-link>
          <div class="det text-ellipsis">
            <router-link class="det-item" to="">餐厅</router-link>
            <span class="fh">/</span>
            <router-link class="det-item" to="">人气菜品</router-link>
            <span class="fh">/</span>
            <router-link class="det-item" to="">下午茶</router-link>
          </div>
        </div>
        <div class="menu-item disabled">
          <router-link to="" class="top-line clearfix">
            <div class="icon-tit">
              <img class="ico" src="~@/assets/images/v2/menu05.png" alt="" />
              <span class="tit">农产</span>
            </div>
            <img class="arrow" src="~@/assets/images/v2/more_arrow.png" alt="" />
          </router-link>
          <div class="det text-ellipsis">
            <router-link class="det-item" to="">果蔬</router-link>
            <span class="fh">/</span>
            <router-link class="det-item" to="">干货</router-link>
            <span class="fh">/</span>
            <router-link class="det-item" to="">产地寻宝</router-link>
          </div>
        </div>
      </div>
      <div class="com focus">
        <el-carousel trigger="click" height="400px">
          <el-carousel-item>
            <router-link to="/act/play">
              <img class="focus-item" src="~@/assets/images/v2/ban02.jpg" alt="" />
            </router-link>
          </el-carousel-item>
          <el-carousel-item>
            <router-link to="/act/recruit">
              <img class="focus-item" src="~@/assets/images/v2/ban03.jpg" alt="" />
            </router-link>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="com acts">
        <div class="common-ico-tit clearfix">
          <div class="ico-tit clearfix">
            <img class="ico" src="~@/assets/images/v2/ico01.png" alt="" />
            <span class="tit">精选活动</span>
          </div>
        </div>

        <router-link to="/act/strawberry" class="act-item">
          <img class="item-img" src="~@/assets/images/v2/act01.jpeg" alt="">
        </router-link>
        <router-link to="/act/citywalk" class="act-item">
          <img class="item-img" src="~@/assets/images/v2/act02.jpeg" alt="">
        </router-link>
        <router-link to="/act/new" class="act-item">
          <img class="item-img" src="~@/assets/images/v2/act03.jpeg" alt="">
        </router-link>
      </div>
    </div>

    <div class="common-vwrap v2-wrap">
      <div class="common-ico-tit clearfix">
        <div class="ico-tit clearfix">
          <img class="ico" src="~@/assets/images/v2/ico02.png" alt="" />
          <span class="tit">民宿酒店排行榜</span>
        </div>
        <router-link to="" class="more-arrow clearfix">
          <span class="more">更多</span>
          <img class="arrow" src="~@/assets/images/v2/more_arrow.png" alt="" />
        </router-link>
      </div>
      <div class="rank-list clearfix">
        <div
          :class="['rank-item', {active: rankIndex === index}]"
          :style="{'background-image': `url(${item.img})`}"
          v-for="(item, index) of rankList"
          :key="index"
          @mouseover="changeRankIndex(index)"
        >
          <div class="tit cent text-ellipsis">{{item.tit}}</div>
          <div class="mask">
            <div class="tit">{{item.tit}}</div>
            <div class="desc">{{item.desc}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="common-vwrap v2-wrap">
      <div class="common-ico-tit clearfix">
        <div class="ico-tit clearfix">
          <img class="ico" src="~@/assets/images/v2/ico03.png" alt="" />
          <span class="tit">休闲假期住哪里</span>
        </div>
        <router-link to="/v2/homestay" class="more-arrow clearfix">
          <span class="more">更多</span>
          <img class="arrow" src="~@/assets/images/v2/more_arrow.png" alt="" />
        </router-link>
      </div>

      <div class="common-room-list clearfix" v-loading="loading">
        <div class="room-item" v-for="(item,index) of storeList" :key="index">
          <router-link class="room-cover" :to="'/v2/homestay/detail?id='+item.id">
            <img class="cov-img img-view" :src="item.houseImge[0].url" alt="" />
          </router-link>
          <div class="room-info">
            <div class="common-price-v2">
              <span class="dw">¥</span>
              <span class="jg">{{item.price}}</span>
            </div>
            <div class="room-tit text-ellipsis">
              <router-link class="link" :to="'/v2/homestay/detail?id='+item.id">{{ item.storeName }}</router-link>
            </div>
            <div class="room-desc text-ellipsis-2">{{ item.storeDesc }}</div>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="common-vwrap v2-wrap">-->
<!--      <div class="common-ico-tit clearfix">-->
<!--        <div class="ico-tit clearfix">-->
<!--          <img class="ico" src="~@/assets/images/v2/ico04.png" alt="" />-->
<!--          <span class="tit">特色商品带回家</span>-->
<!--        </div>-->
<!--        <router-link to="" class="more-arrow clearfix">-->
<!--          <span class="more">更多</span>-->
<!--          <img class="arrow" src="~@/assets/images/v2/more_arrow.png" alt="" />-->
<!--        </router-link>-->
<!--      </div>-->

<!--      <div class="goods-list clearfix">-->
<!--        <div class="goods-item clearfix" v-for="index of 6" :key="index">-->
<!--          <router-link class="goods-cover" to="">-->
<!--            <img class="cov-img img-view" src="~@/assets/images/v2/ban.png" alt="" />-->
<!--          </router-link>-->
<!--          <div class="goods-info">-->
<!--            <div class="goods-tit text-ellipsis-3">-->
<!--              <router-link class="link" to="">临安小核桃仁孕妇坚果零食2023年新货特产干果</router-link>-->
<!--            </div>-->
<!--            <div class="goods-shopname text-ellipsis-2">浙江 杭州 文文山核桃旗舰店</div>-->
<!--            <div class="common-price-v2">-->
<!--              <span class="dw">¥</span>-->
<!--              <span class="jg">930.50</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="page-bottom common-vwrap v2-wrap">-->
<!--      <div class="common-ico-tit clearfix">-->
<!--        <div class="ico-tit clearfix">-->
<!--          <img class="ico" src="~@/assets/images/v2/ico05.png" alt="" />-->
<!--          <span class="tit">新奇农活来体验</span>-->
<!--        </div>-->
<!--        <router-link to="" class="more-arrow clearfix">-->
<!--          <span class="more">更多</span>-->
<!--          <img class="arrow" src="~@/assets/images/v2/more_arrow.png" alt="" />-->
<!--        </router-link>-->
<!--      </div>-->

<!--      <div class="test-list clearfix">-->
<!--        <div class="test-item">-->
<!--          <router-link class="link-img" to="">-->
<!--            <img class="cov-img" src="~@/assets/images/v2/test01.png" alt="" />-->
<!--          </router-link>-->
<!--        </div>-->
<!--        <div class="test-item">-->
<!--          <router-link class="link-img" to="">-->
<!--            <img class="cov-img" src="~@/assets/images/v2/test02.png" alt="" />-->
<!--          </router-link>-->
<!--        </div>-->
<!--        <div class="test-item two">-->
<!--          <router-link class="link-img" to="">-->
<!--            <img class="cov-img" src="~@/assets/images/v2/test03.png" alt="" />-->
<!--          </router-link>-->
<!--          <router-link class="link-img" to="">-->
<!--            <img class="cov-img" src="~@/assets/images/v2/test04.png" alt="" />-->
<!--          </router-link>-->
<!--        </div>-->
<!--        <div class="test-item two">-->
<!--          <router-link class="link-img" to="">-->
<!--            <img class="cov-img" src="~@/assets/images/v2/test05.png" alt="" />-->
<!--          </router-link>-->
<!--          <router-link class="link-img" to="">-->
<!--            <img class="cov-img" src="~@/assets/images/v2/test06.png" alt="" />-->
<!--          </router-link>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <v2-foot />
  </div>
</template>

<script>
  import { _throttle } from '@/plugins/utils'
  import * as apiRoom from "@/api/room";
  import * as apiStore from "@/api/store";

  export default {
    data () {
      return {
        paramsStore: {
          pageNumber: 1,
          pageSize: 8,
          myLatitude: 0,
          myLongitude: 0,
          orderBy: '', // distance
          orderType: '', // asc/desc
          storeDisable: 'OPEN',
          // ids: ['00000000'],//默认一个不存在的ID传，防止这个查询条件为空
          ids: []
        },
        storeRoomList:[],
        storeList:[],
        storeList1:[],
        storeList2:[],
        storeList3:[],
        loading:true,
        rankIndex: 0,
        rankList: [
          {
            img: require('@/assets/images/v2/rank01.jpg'),
            tit: '湖上门堂',
            desc: '建筑为湖上村祖宅，属清末民初家族群居式三合院，旧时也称“大门堂”，合院占地面积775平方米，总建筑面积约1100平方米，砖木结构两层建筑。湖上门堂在中国传统乡村建筑完成真正意义上的自我更新，使旧农居老宅能满足现代人对居住舒适度的高标准要求，在保持传统精神面貌基础上重新焕发生机。'
          },
          {
            img: require('@/assets/images/v2/rank02.jpg'),
            tit: '花轩逸居民宿',
            desc: '独栋纯木质民宿，视野开阔无遮挡，本店拥有亲子房、麻将房、大床房、双床房等多种房型。所有房间均采用高支全棉优质床品，设计简约而不简单，卫浴设施和用品齐全，给您舒适的睡眠体验。'
          },
          {
            img: require('@/assets/images/v2/rank03.jpg'),
            tit: '花影约民宿',
            desc: '风声起，夜流光，偷浮生，半日闲。花影约民宿唯愿您在城市纷扰喧嚣中，觅得一处从容雅致之处。万物皆可“磐” 身心需两“安” 暖风拂夏“花” 笑颜映清“溪” 卧荻如“花” 剪月成“影” 佳期如“约” 。'
          },
          {
            img: require('@/assets/images/v2/rank04.jpg'),
            tit: '金石山庄',
            desc: '山庄将会是一个不错的的住宿之选。倘若在您入住酒店期间有闲暇时间，可以去周边的舞龙峡景区游览。酒店提供的休闲设施，旨在为旅客营造多姿多彩、奢华完美的住宿体验。'
          },
          {
            img: require('@/assets/images/v2/rank05.jpg'),
            tit: '悠客小栈民宿',
            desc: '这里是我们精心准备的家，希望它能为你带来一段温馨难忘的旅途体验。日子缓缓、生活散散；喜欢自己、才能拥抱生活！享受生活，让自己慢下来~'
          },
        ]
      }
    },
    mounted () {
      this.getStoreList();
    },
    methods: {
      async getStoreList () {
        let that = this;
        that.loading = true;
        let paramsStoreRoom = {'isAsc': true}
        if(that.storeRoomList.length===0){
          let storeRoomList = await apiRoom.getStoreListByRoom(paramsStoreRoom)
          console.log("storeRoomList",storeRoomList)
          that.storeRoomList = storeRoomList.data
          that.storeRoomList.forEach((item)=>{
            that.paramsStore.ids.push(item.storeId)
          })
        }
        let storeList = await apiStore.getByPageWithHouseType(this.paramsStore)
        let storeResult = storeList.result.records;
        storeResult.forEach((storeObj, index) => {
          that.storeRoomList.forEach((item)=>{

            if(item.storeId === storeObj.id){
              // console.log(item)
              storeObj.price= item.price
              storeObj.tags = item.tags;
              storeObj.soldNum = item.salesVolume
              if(storeObj.houseImge !== "null" && storeObj.houseImge !== undefined &&storeObj.houseImge !== ''){
                storeObj.houseImge = JSON.parse(storeObj.houseImge)
              }else{
                storeObj.houseImge =[{"url":''}]
              }
              that.storeList.push(storeObj);
            }

          })
        })
        that.storeList = that.storeList.sort(function(a,b){
          return b.soldNum - a.soldNum
        });
        that.storeList1 = that.storeList.slice(0,4);
        that.storeList2 = that.storeList.slice(4,8);
        that.storeList3 = that.storeList.slice(8,12);
        console.log('this.storeList',this.storeList)
        that.loading = false
      },

      changeRankIndex: _throttle(function (index) {
        this.rankIndex = index
      }, 200, true)
    }
  }
</script>

<style lang="scss" scoped>
  .page-bottom {
    margin-bottom: 30px;
  }

  .menu-act {
    .com {
      height: 400px;
      background: #fff;
      border-radius: $border-radius-v2;
    }

    .menus {
      float: left;
      width: 280px;
      padding: 15px 30px 0;

      .menu-item {
        height: 74px;
        padding-top: 15px;
        border-bottom: 1px dotted #E8E9EC;

        &.disabled {
          opacity: .5;
          pointer-events: none;
        }

        &:last-child {
          border-bottom: none;
        }

        .top-line {
          .icon-tit {
            float: left;
            line-height: 20px;

            .ico {
              float: left;
              width: 16px;
              height: 16px;
              margin-top: 2px;
            }

            .tit {
              float: left;
              margin-left: 8px;
              color: #363A44;
              font-size: 16px;
              font-weight: 500;
            }
          }

          .arrow {
            float: right;
            height: 14px;
            margin-top: 3px;
          }
        }

        .det {
          margin-top: 12px;
          line-height: 14px;

          .det-item {
            color: #686B73;

            &:hover {
              color: $light-color-v2;
            }
          }

          .fh {
            margin: 0 6px;
          }
        }
      }
    }

    .focus {
      overflow: hidden;
      float: left;
      width: 580px;
      margin-left: 20px;

      .focus-item {
        width: 100%;
      }

      >>> .el-carousel__arrow {
        display: none;
      }

      >>> .el-carousel__indicator {
        .el-carousel__button {
          width: 10px;
          height: 10px;
          border-radius: 5px;
          opacity: 1;
        }

        &.is-active {
          .el-carousel__button {
            width: 25px;
            background: $light-color-v2;
          }
        }
      }
    }

    .acts {
      float: right;
      width: 280px;
      padding: 20px;

      .common-ico-tit {
        margin-bottom: 20px;
      }

      .act-item {
        display: block;
        margin-top: 10px;

        .item-img {
          display: block;
          width: 100%;
          height: 100px;
          border-radius: $border-radius-v2;
        }
      }
    }
  }

  .rank-list {
    overflow: hidden;
    height: 260px;
    margin-top: 30px;
    border-radius: $border-radius-v2;

    .rank-item {
      float: left;
      position: relative;
      width: 170px;
      height: 260px;
      background-size: cover;
      background-position: center center;
      transition: width .3s;

      .tit {
        color: #fff;
        font-size: 18px;
        font-weight: 600;

        &.cent {
          position: absolute;
          text-align: center;
          bottom: 10px;
          left: 0;
          right: 0;
          padding: 0 20px;
        }
      }

      .desc {
        margin-top: 18px;
        font-size: 14px;
        line-height: 20px;
      }

      .mask {
        opacity: 0;
        width: 100%;
        height: 100%;
        padding: 30px 80px 0 20px;
        color: #fff;
        background: rgba(0, 0, 0, .4);
      }

      &.active {
        width: 440px;

        .mask {
          opacity: 1;
          transition: all .3s .3s;
          // transition-property: all;
          // transition-duration: .3s;
          // transition-delay: .3s;
        }

        .tit.cent {
          opacity: 0;
        }
      }
    }
  }

  .goods-list {
    margin-right: -20px;

    .goods-item {
      float: left;
      width: 360px;
      height: 150px;
      margin-top: 30px;
      margin-right: 20px;

      .goods-cover {
        overflow: hidden;
        float: left;
        width: 150px;
        height: 150px;
        border-radius: $border-radius-v2;
      }

      .goods-info {
        position: relative;
        float: right;
        width: 186px;
        height: 150px;
        margin-right: 12px;

        .goods-tit {
          line-height: 22px;

          .link {
            color: #363A44;
            font-size: 16px;

            &:hover {
              color: $light-color-v2;
            }
          }
        }

        .goods-shopname {
          margin-top: 12px;
          color: #686B73;
          font-size: 12px;
        }

        .common-price-v2 {
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
  }

  .test-list {
    margin-top: 30px;
    margin-right: -20px;

    .test-item {
      float: left;
      width: 265px;
      height: 380px;
      margin-right: 20px;

      .link-img {
        overflow: hidden;
        display: block;
        border-radius: $border-radius-v2;
      }

      &.two {
        .link-img {
          height: 180px;
          margin-bottom: 20px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/saas/v2/Index.vue